import { Link } from "react-router-dom";
import { CheckCircle2, MessageCircle, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileStickyBar } from "@/components/MobileStickyBar";
import { useSeo } from "@/lib/seo";
import { waLink } from "@/data/content";

export default function Grazie() {
  useSeo({
    title: "Grazie! Il tuo preventivo è in arrivo | XMOVE Italia",
    description: "Richiesta ricevuta: un consulente XMOVE ti ricontatterà entro pochi minuti con la tua proposta personalizzata.",
    path: "/grazie/",
  });

  return (
    <div className="pb-[72px] md:pb-0" data-testid="grazie-page">
      <Header />
      <main className="mx-auto flex max-w-2xl flex-col items-center px-5 py-24 text-center lg:py-32">
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: "spring", stiffness: 200, damping: 14 }}
        >
          <CheckCircle2 size={72} className="text-xmove-green" data-testid="grazie-icon" />
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.6 }}>
          <h1 className="mt-7 font-display text-4xl font-bold text-xmove-ink sm:text-5xl" data-testid="grazie-h1">
            Richiesta ricevuta!
          </h1>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-xmove-muted md:text-lg">
            Un consulente XMOVE sta già selezionando le migliori offerte dello stock per te.
            Ti ricontatteremo <b className="text-xmove-ink">entro pochi minuti</b> con la tua proposta personalizzata.
          </p>
          <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
            <a
              href={waLink("Ciao XMOVE, ho appena inviato una richiesta di preventivo dal sito. Vi anticipo qui i dettagli!")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="grazie-whatsapp-btn"
              className="flex items-center gap-2 rounded-xl bg-xmove-orange px-7 py-4 text-sm font-bold text-white shadow-soft transition-all hover:bg-xmove-orangeDark"
            >
              <MessageCircle size={17} /> Velocizza via WhatsApp
            </a>
            <Link
              to="/"
              data-testid="grazie-home-link"
              className="flex items-center gap-2 rounded-xl border border-xmove-ink/15 px-7 py-4 text-sm font-semibold text-xmove-ink transition-colors hover:border-xmove-orange hover:text-xmove-orange"
            >
              <ArrowLeft size={16} /> Torna alla Home
            </Link>
          </div>
        </motion.div>
      </main>
      <Footer />
      <MobileStickyBar />
    </div>
  );
}
